import { render, staticRenderFns } from "./ProviderShowContacts.vue?vue&type=template&id=8be5efea"
import script from "./ProviderShowContacts.vue?vue&type=script&lang=js"
export * from "./ProviderShowContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports